export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  commentCode: { field: 'commentCode', fieldType: 'numeric', type: 'number', required: true },
  commentId: { field: 'commentID', fieldType: 'numeric' },
  commentText: { field: 'commentText', fieldType: 'text', required: true },
  createdOn: { field: 'createdOn', fieldType: 'date' },
  displayOrder: { field: 'displayOrder', fieldType: 'numeric' },
  isBad: { field: 'isBad', fieldType: 'boolean' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' }
};
